"use client";

import Link from "next/link";
import { contactEmail, contactPhone } from "@/config/infos";
import { COMPANY } from "@/config/company";
import { motion } from "framer-motion";
import type { Locale } from "@/config/i18n";
import { INFO_SECTION } from "./locationHubContent";
import { tr } from "@/config/localeText";

export default function InfoSection({ locale = "fr" }: { locale?: Locale }) {
  const chrome = tr(INFO_SECTION, locale);
  return (
    <motion.div
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: 0.45 }}
      className="flex flex-col items-center justify-center gap-4 bg-gold-200 px-4 py-3 text-center text-primaryLoc backdrop-blur-sm sm:flex-row sm:gap-8 sm:px-8"
    >
      <div className="hidden text-sm text-primaryLoc/80 lg:block">
        {chrome.byAppointment}
      </div>
      <hr className="hidden h-6 border-e border-primaryLoc/30 lg:block" />
      <div className="flex flex-col items-center justify-center gap-2 lg:flex-row lg:gap-6">
        <div className="flex flex-col items-center gap-2 lg:flex-row lg:gap-6">
          <Link
            href={`tel:${COMPANY.phoneIntl}`}
            className="text-sm text-primaryLoc/80 transition-colors hover:text-primaryLoc"
          >
            {contactPhone}
          </Link>
          <hr className="w-12 border-t border-primaryLoc/30 lg:hidden" />
          <Link
            href={`mailto:${contactEmail}`}
            className="text-sm text-primaryLoc/80 transition-colors hover:text-primaryLoc"
          >
            {contactEmail}
          </Link>
        </div>
        <hr className="w-12 border-t border-primaryLoc/30 lg:hidden" />
        <Link
          href="/contact"
          className="text-sm text-primaryLoc/80 transition-colors hover:text-primaryLoc"
        >
          {chrome.contactUs}
        </Link>
      </div>
    </motion.div>
  );
}
